{
  "setup_wizard": false,
  "manufacturers_allowed": [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 31
  ],
  "product_exclusions": [],
  "catalog_page_title": "Catalog",
  "items_per_page": 24,
  "catalog_api_key": "fvq5xh7j5720hev7h7k7jsw14not6h9s8fpmxskwbzt5abfzrp",
  "connectm8_crm_url": "https:\/\/services.leadconnectorhq.com\/hooks\/H7PiIYJwsHXBFNLf4IHQ\/webhook-trigger\/41b554f8-99cd-46aa-8b0a-1cc482a79b5e",
  "landing_page_url": "\/",
  "single_page_url": "\/product\/",
  "catalog_pages": true,
  "show_featured_cards": true,
  "show_shop_banner": true,
  "show_pricing": true,
  "colors": { "topbar": "#FFFFFF", "modals": "#FFFFFF", "buttons": "#1565C0" },
  "free_shipping": true,
  "best_sellers": [1],
  "partner_identifier": "1",
  "partner_phone_number": "(888) 574-5120",
  "partner_company_name": "1-800 Office Solutions",
  "partner_website_url": "https:\/\/1800officesolutions.com",
  "run_preapprovals": false
}
